<template>
  <div>
    <Header :selectedApp="selectedApp"></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>cPay Configurations</h2>

        <div class="d-flex justify-content-between align-items-center">
          <!-- No "Create New Entry" here on purpose: the backend only exposes
               list + update/list for cPay today, there is no insert endpoint. -->
          <div></div>
          <input
              type="text"
              class="form-control mb-3"
              placeholder="Search cPay Configurations..."
              v-model="searchText"
              style="width: 20%; position: relative;"
          >
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('cpayConfigurationId')">cPay Configuration Id</th>
              <th class="col-1" @click="toggleSort('cpayName')">cPay Name</th>
              <th class="col-1" @click="toggleSort('checkoutPage')">Checkout Page</th>
              <th class="col-1" @click="toggleSort('paymentGateway')">Payment Gateway</th>
              <th class="col-1" @click="toggleSort('application')">Application</th>
              <th class="col-1" @click="toggleSort('percentage')">Percentage</th>
              <th class="col-1" @click="toggleSort('whatsappEnabled')">WhatsApp</th>
              <th class="col-1" @click="toggleSort('active')">Active</th>
              <th class="col-1" @click="toggleSort('status')">Status</th>
              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.cpayConfigurationId">
              <td class="col-1 text-truncate" v-html="truncateText(config.cpayConfigurationId, 30)"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.cpayName, 30)" @click="selectText" :data-text="config.cpayName"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.checkoutPage, 70)" :title="config.checkoutPage" @click="selectText" :data-text="config.checkoutPage"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.paymentGateway, 70)" :title="config.paymentGateway" @click="selectText" :data-text="config.paymentGateway"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.application, 30)" @click="selectText" :data-text="config.application"></td>
              <td class="col-1 text-truncate">{{ config.percentage }}%</td>
              <td class="col-1 text-truncate">{{ config.whatsappEnabled }}</td>
              <td class="col-1 text-truncate">{{ config.active }}</td>
              <td class="col-1 text-truncate">{{ config.status }}</td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'CpayEdit', params: { id: config.cpayConfigurationId, cpayName: config.cpayName, secret: config.secret, checkoutPage: config.checkoutPage, paymentGateway: config.paymentGateway, application: config.application, percentage: config.percentage, whatsappEnabled: config.whatsappEnabled, active: config.active, status: config.status } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <p class="text-muted mt-2">
          Percentage, Active and Status are set on the
          <router-link :to="{ name: 'PaymentManagement' }">Payment Management</router-link> page, not here —
          that's also where an account is activated/deactivated.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import Cookies from "js-cookie";

export default {
  name: "CpayConfig",
  components: { Header },
  data() {
    return {
      searchText: "",
      cpayConfigList: [],
      sortColumn: "",
      sortDirection: "asc",
      selectedApp: "",
      highlightedElement: null,
    };
  },
  computed: {
    filteredCpayConfigList() {
      const search = this.searchText.toLowerCase().trim();

      let filteredList = this.cpayConfigList.filter((config) => {
        return (
            (config.cpayName && config.cpayName.toLowerCase().includes(search)) ||
            (config.checkoutPage && config.checkoutPage.toLowerCase().includes(search)) ||
            (config.paymentGateway && config.paymentGateway.toLowerCase().includes(search)) ||
            (config.application && config.application.toLowerCase().includes(search))
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === "asc" ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const rawA = a?.[this.sortColumn];
          const rawB = b?.[this.sortColumn];
          const valueA = rawA === null || rawA === undefined ? "" : String(rawA).toLowerCase();
          const valueB = rawB === null || rawB === undefined ? "" : String(rawB).toLowerCase();
          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }

      if (this.selectedApp !== "") {
        filteredList = filteredList.filter((item) => item.application === this.selectedApp);
      }

      return filteredList;
    },
    sortData() {
      return this.filteredCpayConfigList;
    },
  },
  created() {
    this.doLoadCpayConfig();
    document.addEventListener("click", (event) => this.handleClickAnywhere(event));

    const appCookie = Cookies.get("application");
    if (appCookie) this.selectedApp = appCookie;

    this.sortColumn = "cpayName";
  },
  beforeUnmount() {
    document.removeEventListener("click", (event) => this.handleClickAnywhere(event));
  },
  methods: {
    doLoadCpayConfig() {
      AdminService.getCpayConfigurationList()
          .then((data) => {
            this.cpayConfigList = data;
          })
          .catch((error) => {
            console.error("Error loading cPay configuration:", error);
          });
    },

    truncateText(text, limit) {
      if (text === undefined || text === null) return null;
      return text.length > limit ? text.substring(0, limit) + "..." : text;
    },

    async selectText(event) {
      const originalText = event.target.getAttribute("data-text");
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error("Failed to copy text: ", err);
      }
    },

    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = "yellow";
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000);
    },

    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = "";
        this.highlightedElement = null;
      }
    },

    handleClickAnywhere() {
      this.removeHighlight();
    },

    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortColumn = column;
        this.sortDirection = "asc";
      }
    },
  },
};
</script>

<style src="../../assets/style.css"></style>
